import { render, staticRenderFns } from "./AddCart.vue?vue&type=template&id=145b0758&scoped=true&"
import script from "./AddCart.vue?vue&type=script&lang=js&"
export * from "./AddCart.vue?vue&type=script&lang=js&"
import style0 from "./AddCart.vue?vue&type=style&index=0&id=145b0758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b0758",
  null
  
)

export default component.exports